const getApiOrigin = () => {
  if (typeof window !== 'undefined') {
    const host = String(window.location.hostname || '').toLowerCase().trim();

    // Hard-pin canonical production routing for InsightOS web properties.
    if (host.endsWith('insightos.co.uk')) {
      return 'https://api.insightos.co.uk';
    }

    if (host === 'localhost' || host === '127.0.0.1') {
      return 'https://api.insightos.co.uk';
    }
  }

  const envApiOrigin =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_API_ORIGIN ||
    '';

  if (envApiOrigin) {
    return String(envApiOrigin).trim().replace(/\/+$/, '');
  }

  if (typeof window === 'undefined') {
    return 'https://api.insightos.co.uk';
  }

  return 'https://api.insightos.co.uk';
};

export const resolveApiAssetUrl = (value) => {
  if (!value || typeof value !== 'string') return '';
  if (value.startsWith('data:') || value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  if (value.startsWith('api/')) {
    return `${getApiOrigin()}/${value}`;
  }

  if (value.startsWith('/api/')) {
    return `${getApiOrigin()}${value}`;
  }

  return value;
};

const bufferToDataUrl = (bufferLike, mime = 'image/jpeg') => {
  if (!bufferLike) return '';

  const arr = bufferLike?.data || bufferLike;
  if (!arr || typeof arr.length !== 'number') return '';

  let binary = '';
  for (let i = 0; i < arr.length; i += 1) {
    binary += String.fromCharCode(arr[i]);
  }

  try {
    return `data:${mime};base64,${btoa(binary)}`;
  } catch {
    return '';
  }
};

export const getProfilePicSrc = (personOrValue) => {
  if (!personOrValue) return '';

  if (typeof personOrValue === 'string') {
    return resolveApiAssetUrl(personOrValue);
  }

  const fromUrl = resolveApiAssetUrl(personOrValue.ProfilePicUrl || personOrValue.profilePicUrl || '');
  if (fromUrl) return fromUrl;

  if (typeof personOrValue.ProfilePic === 'string') {
    return resolveApiAssetUrl(personOrValue.ProfilePic);
  }

  return bufferToDataUrl(personOrValue.ProfilePic || personOrValue.profilePic);
};

export const getCompanyLogoSrc = (companyOrValue) => {
  if (!companyOrValue) return '';

  if (typeof companyOrValue === 'string') {
    return resolveApiAssetUrl(companyOrValue);
  }

  const fromUrl = resolveApiAssetUrl(companyOrValue.CompanyLogoUrl || companyOrValue.companyLogoUrl || '');
  if (fromUrl) return fromUrl;

  if (typeof companyOrValue.CompanyLogo === 'string') {
    return resolveApiAssetUrl(companyOrValue.CompanyLogo);
  }

  return bufferToDataUrl(companyOrValue.CompanyLogo, 'image/png');
};
